import React, { useEffect, useMemo, useState } from 'react';
import { Table, Button, Icon, message } from 'antd';

import Loading from '$app/shared/components/Loading';

import { Container } from '$app/shared/components/Container';
import { fetchPredefinedPrices, getErrorMessage } from '../../productApi';

function PriceListPage({ history, sku }) {
  const [operations, setOperations] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadPrices = async () => {
      try {
        const nextOperations = await fetchPredefinedPrices();
        if (isMounted) {
          setOperations(nextOperations);
        }
      } catch (error) {
        message.error(getErrorMessage(error));
        if (isMounted) {
          setOperations([]);
        }
      }
    };

    loadPrices();

    return () => {
      isMounted = false;
    };
  }, []);

  const filteredOperations = useMemo(() => {
    if (!operations) {
      return operations;
    }

    return operations.filter((operation) => operation.sku === sku);
  }, [operations, sku]);

  if (!operations) {
    return <Loading />;
  }

  const columns = [
    {
      title: 'Description',
      dataIndex: 'workSummary',
      render: (value, record) => {
        if (value !== 'service') {
          return value;
        }

        return (
          <span>
            {value} / {record.subType}
          </span>
        );
      },
      onFilter: (value, record) => record.type.indexOf(value) === 0,
      filters: [...new Set(filteredOperations.map((operation) => operation.type))].map((type) => ({
        text: type,
        value: type,
      })),
    },
    {
      title: 'Engine',
      dataIndex: 'engineType',
      onFilter: (value, record) => (record.engineType || '').indexOf(value) === 0,
      filters: [...new Set(filteredOperations.map((operation) => operation.engineType))]
        .filter(Boolean)
        .map((engineType) => ({
          text: engineType,
          value: engineType,
        })),
    },
    {
      title: 'Customer Price',
      dataIndex: 'fixedCost',
      sorter: (a, b) => b.fixedCost - a.fixedCost,
      render: (value) => {
        const penceToPounds = (price) => Number((price / 100).toFixed(2));
        return `£${penceToPounds(value)}`;
      },
    },
    {
      title: 'Variant',
      dataIndex: 'variant',
    },
    {
      title: 'Area',
      dataIndex: 'area',
    },
    {
      title: 'Status',
      dataIndex: 'status',
    },
    {
      title: 'Edit',
      render: (record) => (
        <a onClick={() => history.push(`prices/${record.predefinedId}`)}>
          <Icon type="edit" />
        </a>
      ),
    },
  ];

  return (
    <Container>
      <h2>Customer Price Rules</h2>
      <Table
        size="small"
        rowKey={(record) => record.predefinedId}
        pagination={{ pageSize: 20 }}
        dataSource={filteredOperations}
        columns={columns}
      />
      <Button type="primary" htmlType="submit" onClick={() => history.push('newPrice')}>
        Add a New Price
      </Button>
    </Container>
  );
}

export default PriceListPage;
